import React from 'react'
import { projects } from '../utilities/projects_request'
import SkillsDisplay from './SkillsDisplay'
import ProjectPts from './ProjectPts'

export default function Projects() {
  return (
    <section className='sm:flex sm:flex-col
    min-[300px]:grid '
    >
      <div className='row row-cols-1 row-cols-md-2 g-4'>
        {
          projects
            ? (
              <ul>
                {
                  projects.map((project) => {
                    const projectSkills = project.skills_used
                    const projectPoints = [...project.points]
                    return (
                      <div key={project.id} className='flex flex-row flex-wrap place-content-center text-center'>
                        <div className='
                        flex
                        flex-col
                        basis-1/2
                        min-[300px]:basis-0'
                        >
                          {/* Project Name */}
                          <p
                            className='font-bold text-[50px]
                            min-[300px]:text-[40px]'
                          >{project.name}
                          </p>
                          <a
                            href={project.website}
                            className='flex justify-center'
                          >
                            {/* Project Image */}
                            <section className='py-5 relative'>
                              <img
                                src={process.env.PUBLIC_URL + `${project.picture}`} alt='project_site' className='
                              max-w-[650px]
                              max-h-[350px]
                              max-[400px]:w-[350px]
                              max-[400px]:h-[250px]
                              inset-0
                              bg-cover
                              bg-center
                              z-0
                              hover:opacity-0'
                              />
                              <div className='opacity-0 hover:opacity-100 absolute inset-0 z-10 flex justify-center items-center text-6xl'>
                                <ProjectPts projectPoints={projectPoints} />
                              </div>
                            </section>
                          </a>
                        </div>
                        <section className='flex flex-col basis-1/2 text-center place-content-center px-2
                        '
                        >
                          <section>
                            {/* Project Description */}
                            <p>{project.description}</p>
                            {/* Project Credentials */}
                            <p>{project.credentials}</p>
                          </section>
                          <SkillsDisplay projectSkills={projectSkills} />
                          <section className='flex flex-nowrap justify-center place-content-around py-3'>
                            <a href={project.git}><button className='border-2 border-black rounded-full bg-black text-white p-[5px]'>GitHub</button></a> &nbsp;
                            <a href={project.website}><button className='border-2 border-black rounded-full bg-black text-white p-[5px]'>Website</button></a>
                          </section>
                        </section>
                        <hr className='h-[3px] w-[96%]
                        my-20
                        max-[400px]:my-5
                        bg-gray-200 border-0 dark:bg-gray-700'
                        />
                      </div>
                    )
                  })
                }
              </ul>)
            : null
        }
      </div>
    </section>
  )
}
